import * as angular from "angular"

export default angular.module("integrationModule", [])